import * as React from 'react';
import styles from './index.less';
import { FI18n, FUtil } from '@freelog/tools-lib';

interface FIdentityTypeBadgeBadgeProps {
  status?: 'resource' | 'object' | 'exhibit';
}

// const statusTextObj = {
//   resource: FI18n.i18nNext.tAuto('label_resource'),
//   object: FI18n.i18nNext.tAuto('label_object'),
//   exhibit: FI18n.i18nNext.tAuto('lable_exhibit'),
// };

function FIdentityTypeBadge({ status = 'resource' }: FIdentityTypeBadgeBadgeProps) {

  const [$statusTextObj] = FUtil.Hook.useGetState<string>({
    resource: FI18n.i18nNext.tAuto('label_resource'),
    object: FI18n.i18nNext.tAuto('label_object'),
    exhibit: FI18n.i18nNext.tAuto('lable_exhibit'),
  }[status] || FI18n.i18nNext.tAuto('label_resource'));

  return (<label className={styles[status]}>{$statusTextObj}</label>);
}

export default FIdentityTypeBadge;
